import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import AiAttribute from "../domain/AiAttribute";

class AiAttributeService {

    readonly basePath = "/ai-attributes";

    public add(aiAttribute: AiAttribute): Promise<string> {
        return Axios.post(`${this.basePath}`, aiAttribute).then(value => value.data.id);
    }

    public update(id: string, aiAttribute: AiAttribute): Promise<void> {
        return Axios.put(`${this.basePath}/${id}`, aiAttribute);
    }

    public get(id: string): Promise<AiAttribute> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => AiAttribute.fromPOJO(value.data));
    }

    public delete(aiAttribute: AiAttribute): Promise<void> {
        return Axios.delete(`${this.basePath}/${aiAttribute.id}`);
    }

    public getList(queryOptions: QueryOptions): Promise<PagedResult<AiAttribute>> {
        const query = queryOptions.toQueryParams();
        const url = `${this.basePath}?${query}`;

        return Axios.get(url)
            .then(value => {
                const list = value.data.data.map((objectJson: object) => AiAttribute.fromPOJO(objectJson));
                return new PagedResult(value.data.total, list);
            });
    }
}

export default AiAttributeService;
